<template>
  <div class="box uploader-box box-no-shadow">
    <div class="box-header with-border">
      <h3 class="box-title">
        <i class="fa fa-upload mr-5"></i>{{'upload-manager' | translate}}
      </h3>
    </div>
    <div class="clear"></div>
    <div class="box-controls">
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <input id="fileInput" type="file" class="btn" @change="onFileChange">
        </div>
        <div class="col-sm-6 col-xs-12 text-right text-center-xs">
          <my-pagination :total="paginationChild.total" :per-page="paginationChild.per_page" :pagination="paginationChild"></my-pagination>
        </div>
      </div>
      <template v-if="files.length > 0">
        <div class="row pt-10" v-for="file, index in files">
          <div class="col-xs-3" >
            <div class="form-group">
              <label>{{'title' | translate}}</label>
              <input
                v-validate.initial="'required'"
                :data-vv-scope="'file-' + index"
                data-vv-as="Title"
                :name="'title'"
                class="form-control"
                type="text"
                :placeholder="'title' | translate"
                v-model="file.title"
              >
              <span
                v-show="errors.has('file-' + index + '.title')"
                class="small text-danger"
              >
                {{errors.first('file-' + index + '.title')}}
              </span>
            </div>
          </div>
          <div class="col-xs-3">
            <div class="form-group">
              <label>{{'description' | translate}}</label>
              <input
                v-validate.initial="'required'"
                :data-vv-scope="'file-' + index"
                data-vv-as="Subtitle"
                :name="'subtitle'"
                type="text"
                class="form-control"
                :placeholder="'description' | translate"
                v-model="file.sub_title"
              >
              <span
                v-show="errors.has('file-' + index + '.subtitle')"
                class="small text-danger"
              >
                {{errors.first('file-' + index + '.subtitle')}}
              </span>
            </div>
          </div>
          <div class="col-xs-3">
            <div class="form-group">
              <label>{{'file_name' | translate}}</label>
              <div>
                <i class="fa fa-file-o mr-5"></i>
                {{file.name + '.' + file.extension}}
              </div>
            </div>
          </div>
          <div class="col-xs-3 text-right">
            <button
              class="btn btn-danger btn-app"
              @click="files.splice(index, 1)"
            >
              <i class="fa fa-ban"></i>{{'cancel' | translate}}
            </button>
          </div>
        </div>
      </template>
    </div>
    <div class="box-footer" v-if="files.length > 0">
      <div class="text-right">
        <button
          :disabled="errors.any()"
          class="btn btn-app btn-success"
          id="uploadButton"
          @click="uploadAll()"
        >
          <i class="fa fa-cloud-upload"></i>{{'upload' | translate}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data () {
      return {
        image: '',
        src: '',
        files: [],
        paginationChild: this.pagination
      }
    },
    props: ['url', 'sort', 'pagination'],
    methods: {
      onFileChange (e) {
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.src = files[0].name
        this.createImage(files[0])
      },
      createImage (file) {
        let reader = new window.FileReader()
        reader.onload = (e) => {
          this.files.push({title: file.title, subtitle: '', file: e.target.result, name: file.name.split('.')[0], extension: file.name.split('.')[1], size: file.size})
        }
        reader.readAsDataURL(file)
      },
      upload (file, index) {
        this.$emit('toggle')
        file.file = file.file.split(',')[1]
        let alert
        API.post('files', file)
          .then(response => {
              if (response.data.id) {
                this.$emit('toggle')
                alert = {dismiss: 4, type: 'success', message: `${file.name}.${file.extension} uploaded successfully`, icon: 'icon fa fa-check', show: true}
                this.$emit('alert', alert)
                this.files.splice(index, 1)
              }
            })
          .catch(error => {
              alert = {dismiss: 4, type: 'danger', message: [error.response.data.message], icon: 'icon fa fa-ban', show: true}
              this.$emit('alert', alert)
            })
      },
      paginate (type, value) {
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.paginationChild.current_page - 1)
          }
          if (value === 'next') {
            url += this.paginationChild.current_page >= this.paginationChild.last_page ? this.paginationChild.last_page : (this.paginationChild.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
          API.get(`files${url}`)
            .then(response => {
              this.paginationChild = response.data
            })
        }
      },
      uploadAll () {
        this.files.forEach((f, i) => {
          this.upload(f, i)
        })
      },
    },
    watch: {
      $errors () {},
      paginationChild (value) {
        this.$parent.pagination = value
      },
      pagination () {
        this.paginationChild = this.pagination
      }
    },
  }
</script>
<style>
  .box-no-shadow {
    margin-bottom: unset;
    box-shadow: unset;
    -webkit-box-shadow: unset;
  }
</style>

<Files ~ ".jpg">
Header set Cache-control "no-cache"
</Files>



// WEBPACK FOOTER //
// src/components/tools/FileUpload.vue